// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { Navigate } from 'react-router-dom';
const PrivateRoute = ({ isAuthenticated, authenticationPath, component, }) => {
    return isAuthenticated ? component : React.createElement(Navigate, { to: authenticationPath });
};
export { PrivateRoute };
